import { Component, OnInit } from '@angular/core';
import { InitializationService } from 'src/app/base/services/initialization.service';

@Component({
  selector: 'app-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.css']
})
export class BannerCarouselComponent implements OnInit {

  public banner: any[];

  constructor(
    private _config: InitializationService
  ) {
    this.banner = [
      {name: 'banner1', image: this._config.get('SISTEMA.URL.PATHBANNERS') + 'cursos_gratuitos.jpg'},
      {name: 'banner2', image: this._config.get('SISTEMA.URL.PATHBANNERS') + 'finanzas_personales.jpg'},
      {name: 'banner2', image: this._config.get('SISTEMA.URL.PATHBANNERS') + 'marketing_digital.jpg'},
    ]
  }

  ngOnInit(): void {
  }

}
